import styled, { css } from 'styled-components'

const InputStyled = styled.div`
  position: relative;
  input {
    border: 1px solid #d0d0ce;
    height: 5rem;
    font-size: 1.4rem;
    padding-left: 2rem;
    padding-right: 2rem;
    border-radius: 0.5rem;
    display: block;
    width: 100%;
    background-color: #fff;
    &:disabled {
      background: ${(props) => props.theme.lightGray1};
      border: none;
    }
  }

  .input__with__symbol {
    padding-left: 6rem;
  }

  .symbol {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f3f3f3;
    height: 5.4rem;
    width: 5rem;
    position: absolute;
    left: 0.1rem;
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    z-index: -1;
  }
  /* covert */
  ${(props) => {
    return (
      props.covert &&
      css`
        input {
          border: none;
          &:before {
            background-image: url('data:image/svg+xml;base64,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');
            background-repeat: no-repeat;
          }
        }
      `
    )
  }}
`

export default InputStyled
